import { useQuery } from "@tanstack/react-query";

import {
  CategoryTreeParams,
  getCategoryTree,
} from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

// Classes asked for on one level: the most the backend gives in one page
export const CATEGORY_TREE_LIMIT = 200;

const STALE_TIME = 5 * 60 * 1000;

/**
 * TanStack Query hook for one level of the category tree.
 *
 * @param categoryId - The class whose narrower classes are listed; null for
 *   the top of the tree
 * @param enabled - Whether to read it at all
 */
export function useCategoryTree(categoryId: string | null, enabled = true) {
  const params: CategoryTreeParams = {
    ...(categoryId ? { category_id: categoryId } : {}),
    limit: CATEGORY_TREE_LIMIT,
  };
  return useQuery({
    queryKey: queryKeys.productPlane.categoryTree(params),
    queryFn: () => getCategoryTree(params),
    enabled,
    staleTime: STALE_TIME,
  });
}
